import React from 'react';
import { useTranslation } from "react-i18next";

function LevelCard({ number, description, themes }) {
  return (
    <div className="group bg-white h-full px-6 py-8 shadow-md hover:shadow-xl transition-all duration-300 rounded-lg border border-gray-100">
      <div className="flex items-center gap-4 mb-4">
        <div className="w-16 h-16 rounded-full bg-blue-100 text-blue-600 flex items-center justify-center font-bold text-2xl">
          {number}
        </div>
        <h3 className="text-xl font-heading font-bold text-black">
          Niveau {number}
        </h3>
      </div>
      <p className="text-gray-600 mb-6">
        {description}
      </p>
      
      {themes && (
        <div className="mt-4">
          <h4 className="font-bold text-lg mb-2">Thèmes inclus:</h4>
          <ul className="space-y-2">
            {themes.map((theme, index) => (
              <li key={index} className="flex items-start gap-2">
                <span className="text-blue-500">•</span>
                <span>{theme}</span>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}

export default LevelCard;